import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import Typography from 'components/atoms/Typography'
import CustomModal from 'components/molecules/CustomModal'
import './EquipamentoMedicoPopup.scss'

// Mockup visual do pop-up exibido no login: reaparece enquanto o cooperado não responder.
function EquipamentoMedicoPopup({ show = false, onAnswerYes, onAnswerNo }) {
  const history = useHistory()
  const [open, setOpen] = useState(show)
  const [step, setStep] = useState('question')
  const [confirmNotUse, setConfirmNotUse] = useState(false)

  const handleClose = () => setOpen(false)

  const handleYes = () => {
    setOpen(false)
    setStep('question')
    setConfirmNotUse(false)
    if (typeof onAnswerYes === 'function') onAnswerYes()
    history.push('/app/equipamento-medico')
  }

  const handleNo = () => setStep('justify')

  const handleBack = () => {
    setStep('question')
    setConfirmNotUse(false)
  }

  const handleSubmitNo = () => {
    setOpen(false)
    setStep('question')
    setConfirmNotUse(false)
    if (typeof onAnswerNo === 'function') onAnswerNo()
  }

  return (
    <div className="medical-equipment-popup-modal">
      <CustomModal open={open} closeModal={handleClose} size="sm" title="Equipamentos UNIMED">
        {step === 'question' && (
          <div className="text-center">
            <Typography variant="p" color="gray-100">
              Você utiliza algum equipamento médico durante o atendimento aos beneficiários da Unimed?
            </Typography>
            <div className="d-flex justify-content-center mt-3">
              <Button variant="primary" className="mx-1" onClick={handleYes}>Sim</Button>
              <Button variant="primary" className="mx-1" onClick={handleNo}>Não</Button>
            </div>
          </div>
        )}

        {step === 'justify' && (
          <div>
            <div className="mt-2 d-flex align-items-start" style={{ gap: '10px', padding: '0px 25px 0px' }}>
              <input
                type="checkbox"
                id="equipmentConfirmNotUse"
                checked={confirmNotUse}
                onChange={(e) => setConfirmNotUse(e.target.checked)}
                style={{ flexShrink: 0, width: '20px', height: '20px', cursor: 'pointer', marginTop: '2px' }}
              />
              <label htmlFor="equipmentConfirmNotUse" style={{ margin: 0, textAlign: 'left' }}>
                <Typography variant="span" color="gray-100">
                  Declaro que não faço uso de equipamentos médicos durante o atendimento aos beneficiários Unimed.
                </Typography>
              </label>
            </div>
            <div className="d-flex justify-content-center mt-3" style={{ marginBottom: '1rem' }}>
              <Button variant="secondary" className="mx-1" onClick={handleBack}>Voltar</Button>
              <Button variant="primary" className="mx-1" onClick={handleSubmitNo} disabled={!confirmNotUse}>Enviar</Button>
            </div>
          </div>
        )}
      </CustomModal>
    </div>
  )
}

export default EquipamentoMedicoPopup
